export default {
  myTrainingDetail_submit__num: '共{voteQuantity}人提交',
  myTrainingDetail_teacher_score:'講師評分：{teacherScore}分',
  myTrainingDetail_content_score:'內容評分：{contentScore}分',
  myTrainingDetail_organization_score:'組織評分：{organizationScore}分',
  myTrainingDetail_check_schedule:'1304Web-查看日程表',
  myTrainingDetail_no_schedule:'還沒有日程表',
  myTrainingDetail_date_schedule:'第{i}天',
  myTrainingDetail_teacher:'講師：',
  myTrainingDetail_cancel_registration:'取消報名',
  myTrainingDetail_cancel_reason:'請輸入取消報名原因',
  myTrainingDetail_submit_comment1308:'1308Web-提交討論',
  myTrainingDetail_all_course:'全部課程',
  myTrainingDetail_open_time:'開課時間：',
  myTrainingDetail_address_class:'班級地點：',
  myTrainingDetail_lecturer:'講師：  ',
  myTrainingDetail_student_number:'等{studentNumber}人參加該面授班',
  myTrainingDetail_no_student_join:'沒有人報名參與該面授班',
  myTrainingDetail_student_join_num:'{studentNumber}人參加該面授班',
  myTrainingDetail_reported_limited:'已報/限報：',
  myTrainingDetail_registration_deadline:"距離報名截止還有",
  myTrainingDetail_failed_apply_reapply:'報名申請未通過，是否重新報名',
  myTrainingDetail_failed_reason:'未通過原因：',
  myTrainingDetail_registration_start:'距離報名開始還有：',
  myTrainingDetail_registration_no_start:'報名未開始',
  myTrainingDetail_I_sign_up:'我要報名',
  myTrainingDetail_full_registration:"已報滿",
  myTrainingDetail_registration_ended:'報名截止',
  myTrainingDetail_re_apply:'重新報名',
  myTrainingDetail_registration_review:'報名審核中',
  myTrainingDetail_concell_registration_review:'取消報名審核中',
  myTrainingDetail_congratulations_graduation:'恭喜你畢業啦',
  myTrainingDetail_I_want_evaluate:'我要評價',
  myTrainingDetail_check_resources1312:'1312Web-查看資源',
  myTrainingDetail_remain_quantity:'你還有{remainQuantity}次考試機會',
  myTrainingDetail_check_all1311:'1311Web-查看全部',
  myTrainingDetail_total_exam:'全部考試',
  myTrainingDetail_no_graduation_path:'後臺錯誤，找不到畢業紀念冊路徑',
  myTrainingDetail_check_graduation1313:'1313Web-查看畢業紀念冊',
  myTrainingDetail_faceclass13:'13Web-面授班',
  myTrainingDetail_look_graduation_album:'快來看看你的畢業紀念冊！',
  myTrainingDetail_graduation_album:"畢業紀念冊",
  myTrainingDetail_browser_not_support:'您的瀏覽器不支持瀏覽畢業紀念冊',
  myTrainingDetail_no_permission_view:'您沒有查看權限',
  myTrainingDetail_images:'圖片',
  myTrainingDetail_files_type:'僅支持上傳格式為：word、excel、ppt、pdf、jpg、png的附件',
  myTrainingDetail_files_upload_limit:'上傳不超過5個附件',
  myTrainingDetail_files_size_limit:'文件 {fileObj} 大小超過20M，請重新上傳',
  myTrainingDetail_files_empty_limit:'文件內容不可以為空',
  myTrainingDetail_files_value_limit:'最多輸入10000字',
  myTrainingDetail_enclosure:'附件：',
  myTrainingDetail_select:'選擇',
  myTrainingDetail_file_upload_limits:'（可上傳不超過5個附件，格式支持：word、excel、ppt、pdf、jpg、png，每個文件大小為20M以內。）',
  myTrainingDetail_all_live:'全部直播',
  myTrainingDetail_Live_time:"直播時間：",
  myTrainingDetail_anchor_name:'主播：',
  myTrainingDetail_all_questionnaires:'全部問卷',
  myTrainingDetail_no_honor_list:'還沒有榮譽榜',
  myTrainingDetail_submit_comment1303:'1303Web-提交評價',
  myTrainingDetail_go_comment_pages:'1302Web-進入評價頁',
  myTrainingDetail_submit_comment:'提交評價',
  myTrainingDetail_face_class_comment:'面授班評價',
  myTrainingDetail_please_comment:'請對該面授班進行評價',
  myTrainingDetail_Instructor_rating:'講師評分',
  myTrainingDetail_content_rating:'內容評分',
  myTrainingDetail_org_rating:"組織評分",
  myTrainingDetail_rate_placeholder:"寫一些對班級的評價吧 (選填)",
  myTrainingDetail_my_rate:'我的評價:',
  myTrainingDetail_submit_success:'提交評價成功',
  myTrainingDetail_make_online_courses:"製作在線課程",
  myTrainingDetail_individual:"個",
  myTrainingDetail_Live_broadcast:'主播直播',
  myTrainingDetail_face_class_teach:'面授班授課',
  myTrainingDetail_my_lecture_overview:'我的授課概覽',
  myTrainingDetail_no_learn_resource:'你沒有創建過學習資源',
  myTrainingDetail_my_live_broadcast:'我主播的直播',
  myTrainingDetail_my_teach_faceclass:'我授課的面授班',
  myTrainingDetail_deadline:'距離報名截止還有：',
  myTrainingDetail_upload:'上傳附件：',
  myTrainingDetail_voteQuantity:'共{voteQuantity}人提交',
  myTrainingDetail_teacherScore:'講師評分：{teacherScore}分',
  myTrainingDetailcontentScore:'內容評分：{contentScore}分',
  myTrainingDetail_organizationScore:'組織評分：{organizationScore}分 ',
  myTrainingDetail_score:'{score}分',
}
